// extracted by mini-css-extract-plugin
export default {"wrapper":"NestedAccordPart_wrapper__AiTz0","netWrapper":"NestedAccordPart_netWrapper__GQYus"};